export default __webpack_public_path__ + "static/media/62.769fda1e.jpg";